export default "__VITE_ASSET__Cx9YY59t__"